import type { FormField } from '../../types';

export const FIELD_TYPES: Array<{ value: FormField['type']; label: string }> = [
  { value: 'text', label: 'Text' },
  { value: 'email', label: 'Email' },
  { value: 'textarea', label: 'Text Area' },
  { value: 'number', label: 'Number' },
  { value: 'date', label: 'Date' },
  { value: 'phone', label: 'Phone' },
  { value: 'dropdown', label: 'Dropdown' },
  { value: 'address', label: 'Physical / Ship To Address' },
];

export const LAYOUT_OPTIONS = [
  { value: 'full', label: 'Full width' },
  { value: 'half', label: 'Half width (2-col)' },
];

export function createFormField(id: number, sortOrder: number): FormField {
  return {
    id,
    label: '',
    type: 'text',
    isRequired: false,
    sortOrder,
  };
}

export const STATE_PROVINCE_OPTIONS = [
  'Non-US/Canada',
  'AB', 'AK', 'AL', 'AR', 'AZ', 'BC', 'CA', 'CO', 'CT', 'DC', 'DE', 'FL', 'GA', 'GU', 'HI', 'IA', 'ID', 'IL', 'IN',
  'KS', 'KY', 'LA', 'MA', 'MB', 'MD', 'ME', 'MI', 'MN', 'MO', 'MS', 'MT', 'NB', 'NC', 'ND', 'NE', 'NH', 'NJ', 'NL',
  'NM', 'NS', 'NT', 'NU', 'NV', 'NY', 'OH', 'OK', 'ON', 'OR', 'PA', 'PE', 'PR', 'QC', 'RI', 'SC', 'SD', 'SK', 'TN',
  'TX', 'UT', 'VA', 'VI', 'VT', 'WA', 'WI', 'WV', 'WY', 'YT', 'AS', 'FM', 'MH', 'MP', 'PW', 'AE', 'AP', 'AA',
];

export function getFormFieldInputType(type: FormField['type']): string {
  if (type === 'email' || type === 'number' || type === 'date') return type;
  return 'text';
}

// Formats digits into a US-style phone number as the user types, e.g. 555-123-4567.
export function formatPhoneNumber(value: string): string {
  const digits = value.replace(/\D/g, '').slice(0, 10);
  if (digits.length < 4) return digits;
  if (digits.length < 7) return `${digits.slice(0, 3)}-${digits.slice(3)}`;
  return `${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6)}`;
}

// Format-only, never rejects input: US ZIP / ZIP+4 and Canadian A1A 1A1; any other value is left as typed.
export function formatPostalCode(value: string): string {
  const zipPlusFour = value.match(/^(\d{5})([\s-])(\d{0,4})$/);
  if (zipPlusFour) {
    const [, zip, separator, suffix] = zipPlusFour;
    return suffix ? `${zip}-${suffix}` : `${zip}${separator}`;
  }
  const compact = value.replace(/[\s-]/g, '');
  const upper = compact.toUpperCase();
  if (/^[A-Z](\d([A-Z](\d([A-Z]\d?)?)?)?)?$/.test(upper)) {
    return upper.length <= 3 ? upper : `${upper.slice(0, 3)} ${upper.slice(3)}`;
  }
  return value;
}
